import { datadogRum } from '@datadog/browser-rum'

export const trackUserRUM = (visitorId, sessionId) => {
  datadogRum.setUser({
    visitorId,
    sessionId,
  })

  datadogRum.addRumGlobalContext('visitor_id', visitorId)
  datadogRum.addRumGlobalContext('session_id', sessionId)
}
